import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from '../components/Navbar';
import RoutesComponent from '../RoutesComponent';
import { useEffect, useState } from "react";

import EarthMap from "./EarthMap";


function EarthMapVis() {
  const [touristData2022, setTouristData2022] = useState([]);

  useEffect(() => {
    fetch("/data/tourist_data_2022.json")
      .then((response) => response.json())
      .then((data) => setTouristData2022(data));
  }, []);

  return (
    <div>
      {/* <h1>Travel Orb</h1> */}
      <EarthMap data={touristData2022} />
    </div>
  );
};

export default EarthMapVis;